import classNames from 'classnames';
import { FC, InputHTMLAttributes } from 'react';

import './input.scoped.scss';
import { useIntl } from 'react-intl';

interface IProps {
    classWrapper?: string;
    errorType?: keyof typeof ValidationTestType | null;
    rows?: number;
}

type Props = IProps & InputHTMLAttributes<HTMLInputElement> & InputHTMLAttributes<HTMLTextAreaElement>;

export enum ValidationTestType {
    hasValue = 'hasValue',
    isEmail = 'isEmail',
    isNumber = 'isNumber',
}

export const Input: FC<Props> = ({ classWrapper, rows = 5, errorType, ...props }) => {
    const intl = useIntl();

    const ERROR_MESSAGES = {
        hasValue: intl.formatMessage({
            id: 'input.errorHasValue',
            defaultMessage: 'Pflichtfeld darf nicht leer sein',
        }),
        isEmail: intl.formatMessage({
            id: 'input.errorIsEmail',
            defaultMessage: 'E-Mail ist ungültig',
        }),
        isNumber: intl.formatMessage({
            id: 'input.errorIsNumber',
            defaultMessage: 'Bitte geben Sie keine Buchstaben ein',
        }),
    };

    return (
        <div className={classNames('form-group', classWrapper, { 'form-group--error': !!errorType })}>
            {props.type === 'textarea' ? (
                <textarea rows={rows} {...(props as InputHTMLAttributes<HTMLTextAreaElement>)} />
            ) : (
                <input type="text" {...(props as InputHTMLAttributes<HTMLInputElement>)} />
            )}

            {errorType && <span className={'error-block'}>{ERROR_MESSAGES[errorType]}</span>}
        </div>
    );
};
